export const STORAGE_TYPE = {
  SSD: 'SSD',
  'SSD Standard': 'SSD Standard',
  HDD: 'HDD',
  DAS: 'DAS',
};
